import pluck from 'lodash-es/map'
import { deleteItem, replaceBy } from '../services/array-utils'

const defaultValidation = () => true;
const getCandidates = (dictionary, selected) => {
  // Use both $uuid and id as unique identifiers
  var selectedIds = selected.filter(item => item).map(item => item.$uuid || item.id);
  return dictionary.filter(item => item && (item.$uuid || item.id)).reduce((result, item) => {
    const itemId = item.$uuid || item.id;
    if (!selectedIds.includes(itemId)) result.push(item);
    return result;
  }, []);
}

export default () => ({
  transclude: 'element',
  replace: true,
  scope: { selected: "=", dictionary: "=", filters: "=" },
  controller: ["$scope", "pageFromArray", "$attrs", "utils", function ($scope, paginate, $attrs, utils) {
    var selected = $scope.selected,
      candidates = getCandidates($scope.dictionary, selected);

    var selectedPageNumber = 1, candidatePageNumber = 1,
      paginateSelected, paginateCandidate;

    if ($attrs.validate) {
      $scope.isValid = $scope.$parent[$attrs.validate];
      var invalidSelected = selected.filter((resource) => !$scope.isValid(resource, 'init'));
      invalidSelected.forEach(resource => {
        deleteItem(selected, resource);
        candidates.unshift(resource);
      });
    } else {
      $scope.isValid = defaultValidation;
    }

    if ($scope.filters) {
      var updateFilters = function() {
        if ($scope.filters && $scope.filters.current) {
          $scope.sfilter = $scope.cfilter = $scope.filters.current;
        } else if ($scope.filters && $scope.filters[0]) {
          $scope.sfilter = $scope.cfilter = $scope.filters[0];
        }
      };

      updateFilters();

      $scope.$watch(function() {
        return $scope.filters && $scope.filters.current;
      }, function(newFilter, oldFilter) {
        if (newFilter && newFilter !== oldFilter) {
          updateFilters();
          $scope.updateSelectedPage(1);
          $scope.updateCandidatePage(1);
        }
      });

      $scope.$watch("sfilter", (next, prev) => {
        if (next !== prev) $scope.updateSelectedPage(1);
      });
      $scope.$watch("cfilter", (next, prev) => {
        if (next !== prev) $scope.updateCandidatePage(1);
      });

      paginateSelected = function (page) {
        var $$selected = $scope.sfilter.apply(selected);
        return paginate($$selected, page);
      }
      paginateCandidate = function (page) {
        var $$candidates = $scope.cfilter.apply(candidates);
        return paginate($$candidates, page);
      }

      $scope.updateSelectedPage = function(page) {
        var $$selected = $scope.sfilter ? $scope.sfilter.apply(selected) : selected;
        var result = paginate($$selected, page);
        $scope.selectedPage = result;
        selectedPageNumber = result?.$meta?.page || 1;
        return result;
      };

      $scope.updateCandidatePage = function(page) {
        var $$candidates = $scope.cfilter ? $scope.cfilter.apply(candidates) : candidates;
        var result = paginate($$candidates, page);
        $scope.candidatePage = result;
        candidatePageNumber = result?.$meta?.page || 1;
        return result;
      };

      $scope.updateSelectedPage(1);
      $scope.updateCandidatePage(1);
    } else {
      $scope.updateSelectedPage = utils.paginateArray(selected, data => {
        $scope.selectedPage = data;
        selectedPageNumber = data?.$meta?.page || 1;
      });

      $scope.updateCandidatePage = utils.paginateArray(candidates, data => {
        $scope.candidatePage = data;
        candidatePageNumber = data?.$meta?.page || 1;
      });

      paginateSelected = function (page) {
        return paginate(selected, page);
      }
      paginateCandidate = function (page) {
        return paginate(candidates, page);
      }
    }

    var refreshPages = function () {
      $scope.updateSelectedPage(selectedPageNumber);
      $scope.updateCandidatePage(candidatePageNumber);
    }

    $scope.moveResource = function (resource) {
      if (selected.includes(resource)) {
        candidates.push(resource);
        deleteItem(selected, resource);
      } else {
        selected.push(resource);
        deleteItem(candidates, resource);
      }
      refreshPages();
    }

    $scope.movePage = function (page) {
      if (page == $scope.selectedPage) {
        page = page.filter(r => $scope.isValid(r, 'reject'));
        candidates.push(...page);
        page.forEach(resource => deleteItem(selected, resource));
      } else {
        page = page.filter(r => $scope.isValid(r, 'select'));
        if ($scope.excludedSyncResourceIds) {
          page = page.filter(r => r && r.id ? $scope.excludedSyncResourceIds.indexOf(r.id) == -1 : true);
        }
        selected.push(...page);
        page.forEach(resource => deleteItem(candidates, resource));
      }
      refreshPages();
    }

    $scope.$watchCollection("dictionary", function (dictionary) {
      replaceBy(candidates, getCandidates(dictionary, selected));
      refreshPages();
    });

    $scope.$watchCollection("selected", function () {
      refreshPages();
    });

    refreshPages();
  }],
  link: function ($scope, $element, $attrs, ctrl, transcludeFn) {
    transcludeFn($scope, clone => $element.after(clone));
  }
});
